import { useState } from "react"
import "../componentsScreenUsers/createUserPanel.css"
import AsyncSelect from "react-select/async"
import { createTeam } from "../../services/teamService"
import { searchNameByInitial } from "../../services/userServices"

export default function CreateTeamPanel({clousePanel}){

    const [value, setValue] = useState([])

    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const [city, setCity] = useState("")
    const [address, setAddress] = useState("")

    const loadOptions = async (inputValue) => {
        if (!inputValue || inputValue.trim().length < 2) return []
        
        const data = await searchNameByInitial(inputValue.trim())
        
        if (!Array.isArray(data)) return []
        
        return data.map((user) => ({
            value: user.id,
            label: user.name_user
        }))
    }
    
    const handleCreateTeam = async () => {
        const userIds = value.map(v => v.value)
        if(name !== "" && description !== ""){
            const data = await createTeam(name, description, userIds, city, address)
            console.log(data)
        }     
    }

    return(
        <form className="chat-panel">
            <div className="panel-header">
                <p className="ns-form-title">Crear grupo</p>
                <button className="btn-close" onClick={() => clousePanel()}>✕</button>
            </div>

            <div className="ns-field">
                <label className="ns-label">Nombre del grupo</label>
                <input
                    type="text"
                    className="ns-input"
                    placeholder="Escribe el nombre"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </div>
            <div className="ns-field">
                <label className="ns-label">Descripcion</label>
                <input
                    type="text"
                    className="ns-input"
                    placeholder="Escribe el nombre"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </div>
            <div className="ns-field">
                <label className="ns-label">Ciudad</label>
                <input
                    type="text"
                    className="ns-input"
                    placeholder="Escribe el nombre de la ciudad"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                />
            </div>
            <div className="ns-field">
                <label className="ns-label">Direccion</label>
                <input
                    type="text"
                    className="ns-input"
                    placeholder="Escribe la direccion del grupo"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                />
            </div>

            <div className="panel-footer">
                <button className="ns-submit" onClick={handleCreateTeam} disabled={ !name || !description}>
                    Crear
                </button>
            </div>
        </form>
    )
}